import { ulMessageCheckSquare } from '@faceup/icons/ulMessageCheckSquare'
import { ulPlus } from '@faceup/icons/ulPlus'
import { ulSearchSm } from '@faceup/icons/ulSearchSm'
import { Institution, type Plan } from '@faceup/utils'
import { useContext } from 'react'
import type { MenuItem } from '../Components/MenuItems/MenuItems'
import { UserContext } from '../Contexts/UserContext'
import { defineMessages, FormattedMessage } from '../TypedIntl'
import useAnalytics from '../utils/analytics'
import { useInstitution } from './useInstitution'
import { useIsCheckReportAvailable } from './useIsCheckReportAvailable'

const messages = defineMessages({
  createReport: 'FollowUp.InstitutionLayout.createReport',
  createReportForTestingSchool: 'FollowUp.InstitutionLayout.createReportForTestingSchool',
  backToSchoolList: 'FollowUp.InstitutionLayout.backToSchoolList',
  checkReport: 'FollowUp.CheckReport.title',
})

type UseReportMenuItemsParams = {
  plan: Plan | null | undefined
}

export const useReportMenuItems = ({ plan }: UseReportMenuItemsParams): MenuItem[] => {
  const { isCheckReportAvailable } = useIsCheckReportAvailable({ plan })
  const { logout } = useContext(UserContext)
  const institution = useInstitution()
  const { track } = useAnalytics()

  const isTestingSchool = institution?.isTesting === true && institution.type === Institution.School

  return [
    {
      key: 'createReport',
      url: routes => routes.createReport(),
      onClick: () => track('Create report button clicked'),
      icon: ulPlus,
      label: isTestingSchool ? (
        <FormattedMessage {...messages.createReportForTestingSchool} />
      ) : (
        <FormattedMessage {...messages.createReport} />
      ),
      variant: 'filled',
      dataTest: 'menu-item-create',
    },
    ...(isCheckReportAvailable
      ? [
          {
            key: 'checkReport',
            url: routes => routes.checkReport(),
            icon: ulMessageCheckSquare,
            label: <FormattedMessage {...messages.checkReport} />,
            dataTest: 'menu-item-check',
          } satisfies MenuItem,
        ]
      : []),
    ...(isTestingSchool
      ? [
          {
            key: 'logout',
            onClick: logout,
            icon: ulSearchSm,
            label: <FormattedMessage {...messages.backToSchoolList} />,
          } satisfies MenuItem,
        ]
      : []),
  ]
}
